import { Flex } from "@mantine/core"
import { useHover } from "@mantine/hooks"
import { MouseEventHandler } from "react"

import { useDnDContext } from "@costory/front/components/FileExplorer/DnDContext"
import {
  FileListItem,
  ROW_HEIGHT,
} from "@costory/front/components/FileExplorer/FileListItem"
import {
  DashboardLeafProps,
  SavedViewLeafProps,
} from "@costory/front/components/FileExplorer/TreeExplorer"

type DefaultFileLeafProps = (DashboardLeafProps | SavedViewLeafProps) & {
  disableHighlightStyle?: boolean
  disabled?: boolean
}

export const DefaultFileLeaf = ({
  node: {
    value,
    label,
    nodeProps: { onSelect, type, onDoubleClick, ...nodeProps },
  },
  selected,
  elementProps,
  disableHighlightStyle = false,
  disabled = false,
}: DefaultFileLeafProps) => {
  const { ref, hovered } = useHover()
  const { setDraggedFile } = useDnDContext()

  const handleDoubleClick: MouseEventHandler<HTMLDivElement> = (e) => {
    e.stopPropagation()
    onDoubleClick?.(e)
  }

  const handleDragStart = () => {
    setDraggedFile({
      id: value,
      type,
      componentType: nodeProps.componentType,
      templateFolder: nodeProps.templateFolder || false,
    })
  }

  const handleDragEnd = () => {
    setDraggedFile(null)
  }

  return (
    <Flex
      {...elementProps}
      ref={ref}
      w="100%"
      h={ROW_HEIGHT}
      align="center"
      mb={4}
      bg={
        selected ? "surfaceSelected" : hovered ? "surfaceHover" : "transparent"
      }
      style={{ borderRadius: 8, pointerEvents: disabled ? "none" : "auto" }}
      onClick={disabled ? undefined : onSelect}
      onDoubleClick={disabled ? undefined : handleDoubleClick}
      pr={8}
      draggable={!nodeProps.templateFolder && !disabled}
      onDragStart={disabled ? undefined : handleDragStart}
      onDragEnd={disabled ? undefined : handleDragEnd}
    >
      <FileListItem
        {...nodeProps}
        id={value}
        type={type}
        label={label as string}
        onClick={(e: React.MouseEvent<HTMLDivElement>) =>
          onDoubleClick && onDoubleClick(e)
        }
        disableHighlightStyle={disableHighlightStyle}
        disabled={disabled}
      />
    </Flex>
  )
}
